import React from 'react';
// assets
import styles from './author.module.css';
// interface
import { PostAuthor } from '../../Types';

const AuthorOfQuote: React.FC<PostAuthor> = ({ name, title, photo }) => {
  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src={photo?.publicURL} alt={name} className={styles.ava} />
      </div>
      <div>
        <h4 className={styles.name}>{name}</h4>
        <p className={styles.title}>{title}</p>
      </div>
    </div>
  );
};

export default AuthorOfQuote;
